import { useEffect, useState } from 'react';

import { getEngagementByAddress } from '../pages/MyRewards/rewards.service';
import { useAccount } from 'wagmi';
import { ContractNames } from '@airdao/bond-periphery';
import useBondPeripheryContracts from '../contexts/BondPeripheryContext/useBondPeriphery';
import { BigNumber } from 'ethers';

interface EngagementDataProps {
  address: string;
  bondBuyCount: number;
  bondCreateCount: number;
  bondRedeemCount: number;
  bondSellCount: number;
  id: string;
  swordStake: number;
  kosDiscount: BigNumber;
}

const useGetEngagementByAddress = () => {
  const { address: account } = useAccount();
  const peripheryContracts: any = useBondPeripheryContracts();
  const [data, setData] = useState<EngagementDataProps>({
    address: '',
    bondBuyCount: 0,
    bondCreateCount: 0,
    bondRedeemCount: 0,
    bondSellCount: 0,
    id: '',
    swordStake: 0,
    kosDiscount: BigNumber.from('0'),
  });

  useEffect(() => {
    if (account) {
      (async () => {
        const engagementData = await getEngagementByAddress(account);
        if (engagementData) {
          setData((state) => ({...state, ...engagementData}));
        }
      })();
      const contract = peripheryContracts.getContractByName(ContractNames.EngagementDiscountTierManager);
      contract.getDiscount(account)
        .then((res: BigNumber) => setData((state) => ({...state, kosDiscount: res})))
    }
  }, [account]);

  return data;
};

export default useGetEngagementByAddress;
